<template>
  <transition name="fade">
    <b-img
      fluid
      :src="TouchableImage"
      class="touchable-indicator pulse"
    />
  </transition>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import TouchableImage from '@/assets/imgs/touchable.svg'

@Component
export default class TouchableIndicator extends Vue {
  TouchableImage = TouchableImage
}
</script>

<style scoped>
.touchable-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 17%;
  transform: translate(-50%, -50%);
  opacity: 0.95;
  pointer-events: none;
  z-index: 1000;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
  animation: none !important;
}

.fade-leave-to {
  opacity: 0;
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.95;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.04);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.95;
  }
}

.pulse {
  animation: pulse 1.1s infinite;
}
</style>
